<template>
<div class="page-title">
    <div class="title">
        <h3>Online Bookings</h3>
    </div>
    <div class="filters">
        <el-form
            label-position="top"
        >
            <el-row>
                <el-col :span="2">
                    <el-form-item label="Stage">
                        <el-select v-model="form.stage"  placeholder="Select" size="small" >
                            <el-option
                                v-for="item in stages"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="2">
                    <el-form-item class="ml-2" label="Booking Type">
                        <el-select v-model="form.types"  placeholder="Select" size="small" >
                            <el-option
                                v-for="item in btypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="3">
                    <el-form-item class="ml-2" label="Date Type">
                        <el-select v-model="form.btype"  placeholder="Select" size="small">
                            <el-option
                                v-for="item in types"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item class="ml-2" label="Date Range" size="small">
                        <el-date-picker
                            v-model="form.daterange"
                            type="daterange"
                            unlink-panels
                            range-separator="-"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            :shortcuts="dateshortcuts"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"


                        />
                    </el-form-item>
                </el-col>


                <el-col :span="3">
                    <el-form-item class="ml-2" label=" .">
                    <el-button @click="getlist()"  type="primary" size="small"  round >Apply Filters</el-button>
                    </el-form-item>
                </el-col>
            </el-row>



        </el-form>



    </div>
</div>

    <div v-if="!loading">
        <el-card class="box-card mt-2 booking-list-box" v-for="booking in bookings" :key="booking.id" @click="openbooking(booking.viewlink)">
            <template #header>
                <el-row >
                    <el-col :span="6">
                        <el-tag class="mr-2 bdark" effect="dark" >CDM{{booking.id}}</el-tag>
                        <el-tag class="mr-2" style="" >
                            {{booking.booking_date}}</el-tag>
                        <el-tag class="mr-2">
                            {{booking.booking_id}}</el-tag>

                    </el-col>
                    <el-col :span="18" >
                        <el-row justify="end">
                            <el-tag class="mr-2" effect="dark" :type="booking.status=='Booked'? 'success' : booking.status=='Inprogress'? 'warning' : 'danger'" >{{booking.status}}</el-tag>
                            <el-tag class="mr-2" effect="dark" :type="booking.payment=='Paid'? 'success'  : 'danger'" >Payment {{booking.payment}}</el-tag>

                        </el-row>
                    </el-col>

                </el-row>


            </template>
            <div  class="booking-contents">

                <div>
                    <p class="lbl">Services</p>
                    <p class="vlv">
                        <el-tag class="mr-2" v-for="service in booking.services" style="" >
                            {{service}}</el-tag>

                    </p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Email</p>
                    <p class="vlv">{{booking.email}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Mobile</p>
                    <p class="vlv">{{booking.phone}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Source</p>
                    <p class="vlv">{{booking.source}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Destination</p>
                    <p class="vlv">{{booking.destination}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Departure Date</p>
                    <p class="vlv">{{booking.travelStartDate}}</p>
                </div>
                <el-divider direction="vertical" />
                <div>
                    <p class="lbl">Amount</p>
                    <p class="vlv">{{booking.amount}}</p>
                </div>


            </div>
        </el-card>
    </div>
    <div v-else>
        <el-card class="box-card mt-2 booking-list-box" v-for="i in 7" :key="i">
            <el-skeleton :rows="1" animated />
        </el-card>

    </div>

</template>
<style>

</style>
<script>
import  { ElSelect, ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton  } from 'element-plus'
import 'element-plus/dist/index.css'
import moment from 'moment'
export default {
    name: "BookingList",
    components: { ElSelect,ElOption,ElDatePicker,ElFormItem,ElForm,ElCol,ElRow,ElButton,ElCard,ElTag,ElAvatar,ElDivider,ElSkeleton },
    data() {
        return {
            loading: true,
            form:{
                stage:'',
                type:'0',
                daterange:[moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')],
                user:'',
                btype:''
            },
            stages:[
                {
                    value:'',
                    label:'All'
                },
                {
                    label:'Booked',
                    value:'SUCCESS'
                },
                {
                    label:'On Hold',
                    value:'INPROGRESS'
                },
                {
                    label:'Pending',
                    value:'PENDING'
                }
            ],
            btypes:[
                {
                    value:'',
                    label:'All'
                },
                {
                    value:'Flight',
                    label:'Flight'
                }
            ],
            types:[
                {
                    value:'0',
                    label:'Booking Date'
                },
                {
                    value:'1',
                    label:'Departure Date'
                }

            ],
            dateshortcuts : [
                {
                    text: 'This Month',
                    value: () => {

                        return [moment().startOf('month').format('YYYY-MM-DD'),moment().endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last month',
                    value: () => {

                        return [moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Last 3 months',
                    value: () => {
                        return [moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'),moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')]

                    },
                },
                {
                    text: 'Next month',
                    value: () => {

                        return [moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().add(1, 'month').endOf('month').format('YYYY-MM-DD')]
                    },
                },
                {
                    text: 'Next 3 months',
                    value: () => {
                        return [moment().add(1, 'month').startOf('month').format('YYYY-MM-DD'),moment().add(3, 'month').endOf('month').format('YYYY-MM-DD')]

                    },
                },
                {
                    text: 'Next 10 Days',
                    value: () => {

                        return [moment().add(1, 'day').format('YYYY-MM-DD'),moment().add(10, 'day').format('YYYY-MM-DD')]
                    },
                },
            ],
            bookings:[],
            underusers:[]
        }
    },
    mounted() {
        this.getlist();
    },
    methods: {
        getlist() {
            this.loading=true;
            let currentObj = this;
            axios.post('/onlinebookings/list',this.form).then(function (response) {
                currentObj.bookings=response.data.bookings;
                currentObj.loading=false;

            })
                .catch(function (error) {
                    currentObj.loading=false;
                });
        },
        openbooking(link){
            window.open(link, "_blank", "width="+screen.availWidth+",height="+screen.availHeight)

        }
    }
}
</script>

<style scoped>

</style>
